import * as React from 'react';
import {ComboInfo} from "../../fbobjects/ComboInfo";
import DCComboRow from "../DCComboRow/index";
import DCLevelHeader from "../DCLevelHeader/index";
import './cdsinglelevelcontainer.css'
import Player from "../../fbobjects/Player";
import PlayerAllItemsComponent from "../PlayerAllItemsComponent/index";
import GoogleSheetDB from "../../fbobjects/GoogleSheetDB";
import {Calculation} from "../../fbobjects/calculation/Calculation";
import AbilityDisplayC from "../AbilityDisplayC/index";
import RiotDB from "../../fbobjects/RiotDB";

interface DCSingleLevelContainerProps {
    source:Player;
    target:Player;
    combos:ComboInfo[];
    level:number;
}

export default class DCSingleLevelContainer extends React.Component<DCSingleLevelContainerProps,any> {

    props:DCSingleLevelContainerProps;

    constructor(props:DCSingleLevelContainerProps){
        super(props);
        this.props = props;
        this.state = {
            combos: this.props.combos,

        }
    }

    //TODO sort the combos by their damage

    componentWillReceiveProps(nextProps){
        this.setState({combos:nextProps.combos});
    }

    renderAllPlayersItems():any[]{
        let players = [this.props.source, this.props.target];
        let allPlayerItems = [];
        for (let i = 0; i < players.length; i++) {
            let player = players[i];
            allPlayerItems.push(<PlayerAllItemsComponent key={i} player={player} level={this.props.level}/>)
        }
        return allPlayerItems;
    }

    calculateHighestDamageCombo():number{
        let highestDamage = [];
        let combos = this.props.combos;
        for (let i = 0; i < combos.length; i++) {
            let combo = combos[i];
            let comboDamage = this.calculateDamageDealt(combo);
            if (highestDamage[0] == undefined){
                highestDamage.push(comboDamage);
            }
            else if (comboDamage > highestDamage[0]){
                highestDamage.pop();
                highestDamage.push(comboDamage);
            }
        }
        return highestDamage[0].toFixed(0);
    }

    handleOnModifierClick(abilityName,isNowOn){

        if (isNowOn == true) {
            let modifiedCombo = this.state.combos;
            for (let i = 0; i < modifiedCombo.length; i++) {
                modifiedCombo[i].abilities.push(GoogleSheetDB.getAbilityByName(abilityName))
            }
            this.setState({combos:modifiedCombo});
        }
        else if (isNowOn == false){
            let combos = this.state.combos;
            for (let i = 0; i < combos.length; i++) {
                let combo = combos[i];
                let abilities = combo.abilities;
                for (let j = 0; j < abilities.length; j++) {
                    let ability = abilities[j];
                    if (ability.name == abilityName){
                        abilities.splice(j, 1)
                    }
                }
            }
            this.setState({combos:combos})
        }
    }

    renderDamageModifier(abilityName, type){
        let googleSheetAbility = GoogleSheetDB.getAbilityByName(abilityName);
        let damageInfo = Calculation.calculatePlayerAbilityDamage(this.props.source, this.props.target, googleSheetAbility, this.props.level);
        if (type == "summoner"){
            let summonerSpellIcon = RiotDB.getSummonerSpellImgUrl(abilityName);
            return <AbilityDisplayC ability={googleSheetAbility}
                                    icon={summonerSpellIcon}
                                    hasImage={true}
                                    damageInfo={damageInfo}
                                    onClick={(abilityName,isNowOn)=>this.handleOnModifierClick(abilityName,isNowOn)}
                                    isDamageModifier={true}
            />
        }
        else if (type == "mastery"){
            let masteryIcon = RiotDB.getMasteryImgUrl(abilityName);
            return <AbilityDisplayC ability={googleSheetAbility}
                                    icon={masteryIcon}
                                    hasImage={true}
                                    damageInfo={damageInfo}
                                    onClick={(abilityName,isNowOn)=>this.handleOnModifierClick(abilityName,isNowOn)}
                                    isDamageModifier={true}
            />
        }
        return <div></div>
    }

    calculateDamageDealt(combo){
        return Calculation.calculatePlayerComboDamage(this.props.source, this.props.target, combo, this.props.level).damageNumber;
    }

    getChampionCombos(){
        let championCombos = this.props.combos;

        let combosToRender = championCombos.map((combo)=>{
            if (!isNaN(this.calculateDamageDealt(combo))){
                return <DCComboRow combo={combo} source={this.props.source} target={this.props.target} key={combo.comboName} level={this.props.level}/>
            }
            return <div key={combo.comboName} className="no-combo-display">Oops! There's a combo here, but one of the abilities hasn't been skilled up yet</div>;
        });

        return combosToRender;
    }

    renderKillRange(){
        if (isNaN(this.calculateHighestDamageCombo())) return <div></div>;
        return <div className="kill-range-text">
            Kill {this.props.target.selectedChampion} at <span className="kill-range-span">{this.calculateHighestDamageCombo()} HP</span>
        </div>
    }


    render(){
        return(
            <div className="single-level-container">
                <div className="header-row">
                    <div className="level">
                        <div className="separator-left"/>
                        <div className="level-text">LEVEL {this.props.level}</div>
                        <div className="separator-right"/>
                    </div>
                    <div className="kill-range">
                        {this.renderKillRange()}
                    </div>
                    <div className="editable-items">
                        <div className="champion-items">
                            {this.renderAllPlayersItems()}
                        </div>
                        <div className="modifiers-container">
                            <div className="modifier-text">
                                Damage Modifiers
                            </div>
                            <div className="modifier-items">
                                <div className="modifier-item">
                                    {this.renderDamageModifier('Ignite', "summoner")}
                                </div>
                                <div className="modifier-item">
                                    {this.renderDamageModifier("Thunderlord's Decree", "mastery")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header-row">
                    {this.getChampionCombos()}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/DCSingleLevelContainer/index.tsx